import axiosInstance from "./AuthIntercept";
import { DOMAIN_CLIENT } from "./Constant";

/**
 * Get an ESID Pre-AWB Export Customs Reference by Id
 * @param {*} id
 * @returns
 */
export function GetEsidPreAwbExpCusRefById(id = 0) {
  return axiosInstance.get(`${DOMAIN_CLIENT}EsidPreAwbExpCusRef/GetById/${id}`);
}

/**
 * Get the list of ESID Pre-AWB Export Customs References by ESID Id
 * @param {*} esidId
 * @returns
 */
export function GetEsidPreAwbExpCusRefByEsidId(esidId = 0) {
  return axiosInstance.get(`${DOMAIN_CLIENT}EsidPreAwbExpCusRef/GetByEsidId/${esidId}`);
}

/**
 * Get the list of ESID Pre-AWB Export Customs References by AWB
 * @param {*} awbPfx
 * @param {*} awbNum
 * @returns
 */
export function GetEsidPreAwbExpCusRefByAwb(awbPfx = '', awbNum = '') {
  return axiosInstance.get(`${DOMAIN_CLIENT}EsidPreAwbExpCusRef/GetByAwb?awbPfx=${awbPfx}&awbNum=${awbNum}`);
}

/**
 * Create an ESID Pre-AWB Export Customs Reference
 * @param {*} data
 * @returns
 */
export function CreateEsidPreAwbExpCusRef(data) {
  return axiosInstance.post(`${DOMAIN_CLIENT}EsidPreAwbExpCusRef/Create`, data);
}

/**
 * Update an ESID Pre-AWB Export Customs Reference
 * @param {*} id
 * @param {*} data
 * @returns
 */
export function UpdateEsidPreAwbExpCusRef(id = 0, data) {
  return axiosInstance.put(`${DOMAIN_CLIENT}EsidPreAwbExpCusRef/Update/${id}`, data);
}

/**
 * Delete an ESID Pre-AWB Export Customs Reference
 * @param {*} id
 * @returns
 */
export function DeleteEsidPreAwbExpCusRef(id = 0) {
  return axiosInstance.post(`${DOMAIN_CLIENT}EsidPreAwbExpCusRef/Delete/${id}`);
}

/**
 * Import ESID Pre-AWB Export Customs References from an Excel file
 * @param {*} esidId
 * @param {*} file
 * @returns
 */
export function ImportExcelEsidPreAwbExpCusRef(esidId, file) {
  const formData = new FormData();
  formData.append('file', file);
  return axiosInstance.post(`${DOMAIN_CLIENT}EsidPreAwbExpCusRef/ImportExcel?esidId=${esidId}`, formData);
}
